module.exports = __webpack_public_path__ + "1e855cbe49bfc5fa9232b2187dfac636.svg";